import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import LogoCarousel from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

import EmailFormSection from 'views/Academy/components/EmailFormSection'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `We empower every team with good data`,
  description: `Segment is a customer data platform that helps your entire company become analytics experts. We collect user events from your web and mobile apps, and make it possible for every team to use that data to make decisions, power tools, and drive growth.`,
  ctaTitle: `Learn more`,
  ctaHref: `/customer-data-platform/`,
  logoCarouselHeading: `The best companies are built on unified customer data`,
}

const logos = [
  carouselLogos.IBM,
  carouselLogos.DIGITAL_OCEAN,
  carouselLogos.ATLASSIAN,
  carouselLogos.TRIVAGO,
  carouselLogos.LEVIS,
  carouselLogos.FOX,
]

const CtaSection: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <EmailFormSection />
      <StyledSectionBase variant="centered">
        <Section.Copy>
          <StyledCopyTextBase centered={true}>
            <StyledCopyTextHeading tag="h3">{copy.heading}</StyledCopyTextHeading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
            <CopyText.Link href={getAbsoluteUrl(copy.ctaHref, pageConfig)}>{copy.ctaTitle}</CopyText.Link>
          </StyledCopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <StyledLogoCarousel heading={copy.logoCarouselHeading} logos={logos} />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const StyledLogoCarousel = styled(LogoCarousel)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-top: 40px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 40px;
  }
`

const StyledCopyTextHeading = styled(CopyText.Heading)`
  max-width: 400px;
  margin: 0 auto;
`

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 684px;
`

const Wrapper = styled.div``

export default CtaSection
